export class FetchCartResponse {
  /**
   * @param {Object} data
   * @param {string} data.cartId
   * @param {Array} data.items
   */
  constructor({ cartId, items }) {
    this.shoppingCartId = cartId;
    this.products = items;
  }
}
